var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WmActionMenu, WmButton, WmMenuitem, WmSnackbar, } from "@watermarkinsights/ripple-react";
import DeleteModal from "../common/component/DeleteWmModal";
import Flyout from "../common/component/Flyout";
import EditModalWithTwoButton from "../common/component/EditModalWithTwoButton";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import translate from "../../i18n/translate";
import { timelineSelector, openAddSectionModal, addSectionToTimeline, addSubSectionToTimeline, editSection, deleteSection, editSubSection, deleteSubSection, closeSnackbar, closeAddSectionModal, setModalTitle, openDeleteSectionModal, setTitleError, setEditTimeline, updateSubSectionBulk, placeSubSectionToNewPosition, commitCacheTimelineData, setBlockMovement, placeSecSubsecToNewPositionKeyboard, setCacheTimelineData, setAriaMoveText, } from "./TimelineSlice";
import { closeFlyout, openFlyout, focusButtonComponent, navigateToElement, focusActionMenuComponent, } from "../../static/js/commons.js";
import { toggleHandler, subtoggleHandler } from "../common/commonActions";
import DraggableItem from "../../features/common/component/DraggableItem";
import DraggableArea from "../../features/common/component/DraggableArea";
import DropZone from "../../features/common/component/DropZone";
import Constants from "../common/constants/applicationConstants.json";
import { useIntl } from "react-intl";
export default function EditTimeline() {
    const dispatch = useDispatch();
    const { timelineData, cacheTimelineData, addSectionModal, deleteSectionModal, currentSortOrder, renderType, currentSectionUuid, snackNotifications, currentTimelineUuid, savedTitle, modalTitle, titleError, deletedSubSectionUuid, showEditableTimeline, blockMovement, ariaMoveText, } = useSelector(timelineSelector);
    const [openAddEditModal, setOpenAddEditModal] = useState(false);
    const [isDeleteModelOpen, setIsDeleteModalOpen] = useState(false);
    const timelineSections = cacheTimelineData.sections;
    const inputRef = useRef();
    const [draggedItem, setDraggedItem] = useState("");
    const [draggedEnterItem, setDraggedEnterItem] = useState("");
    const [isDragStarted, setIsDragStarted] = useState(false);
    const [category, setCategory] = useState("");
    const [keysDraggedEnterItem, setKeysDraggedEnterItem] = useState("");
    const [isElementReoderUsingKeyboard, setIsElementReoderUsingKeyboard] = useState(false);
    const [enableLiveRegion, setEnableLiveRegion] = useState(false);
    const [liveAriaObject, setLiveAriaObject] = useState({});
    const moveText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.moveText",
    });
    const grabText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.grabText",
    });
    const dropText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.dropText",
    });
    const movedToPosition = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.movedToPosition",
    });
    const grabInfoText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.grabInfoText",
    });
    const subSectionText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.subSectionText",
    });
    const sectionText = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.sectionText",
    });
    const elementReleased = useIntl().formatMessage({
        id: "app.viewTimeline.dragNdrop.elementReleased",
    });
    useEffect(() => {
        if (titleError) {
            inputRef.current.focus();
        }
    }, [titleError]);
    const closeEditTimelineHandler = (event) => {
        event.preventDefault();
        closeFlyout();
        dispatch(setEditTimeline(false));
        focusButtonComponent("edit-timeline");
    };
    useEffect(() => {
        if (showEditableTimeline) {
            setTimeout(() => openFlyout("edit-timeline-flyout", "edit-timeline", "add-section-1"), 200);
        }
    }, [showEditableTimeline]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (!deleteSectionModal && currentSortOrder && currentSortOrder > 0) {
            if (renderType === "delete-section") {
                if (timelineData.sections.length === 0) {
                    focusButtonComponent("add-section-1");
                }
                else if (timelineData.sections.length === 1) {
                    focusActionMenuComponent("section-menu-" + timelineData.sections[0].uuid);
                }
                else {
                    const filtered = timelineData.sections
                        .filter((sec) => sec.sortOrder > currentSortOrder)
                        .sort((section) => section.sortOrder);
                    if (filtered.length) {
                        focusActionMenuComponent("section-menu-" + filtered[0].uuid);
                    }
                    else {
                        const filteredBelow = timelineData.sections
                            .filter((sec) => sec.sortOrder <= currentSortOrder)
                            .sort((section) => section.sortOrder);
                        if (filteredBelow.length) {
                            focusActionMenuComponent("section-menu-" + filteredBelow[filteredBelow.length - 1].uuid);
                        }
                    }
                }
            }
            else if (renderType === "delete-subsection") {
                const indexSection = timelineData.sections.findIndex((s) => s.uuid === deletedSubSectionUuid);
                if (((_a = timelineData.sections[indexSection]) === null || _a === void 0 ? void 0 : _a.subSections.length) === 0) {
                    focusButtonComponent("add-subsection-" + deletedSubSectionUuid);
                }
                else if (((_b = timelineData.sections[indexSection]) === null || _b === void 0 ? void 0 : _b.subSections.length) === 1) {
                    focusActionMenuComponent("subsection-menu-" +
                        ((_c = timelineData.sections[indexSection]) === null || _c === void 0 ? void 0 : _c.subSections[0].uuid));
                }
                else if (((_d = timelineData.sections[indexSection]) === null || _d === void 0 ? void 0 : _d.subSections.length) > 1) {
                    if (indexSection != -1) {
                        const filtered = (_e = timelineData.sections[indexSection]) === null || _e === void 0 ? void 0 : _e.subSections.filter((sec) => sec.sortOrder > currentSortOrder).sort((section) => section.sortOrder);
                        if (filtered.length)
                            focusActionMenuComponent("subsection-menu-" + filtered[0].uuid);
                        else {
                            const filteredBelow = (_f = timelineData.sections[indexSection]) === null || _f === void 0 ? void 0 : _f.subSections.filter((sec) => sec.sortOrder <= currentSortOrder).sort((section) => section.sortOrder);
                            if (filteredBelow.length) {
                                focusActionMenuComponent("subsection-menu-" +
                                    filteredBelow[filteredBelow.length - 1].uuid);
                            }
                        }
                    }
                }
            }
        }
    }, [deleteSectionModal]);
    const renderLiveRegion = () => {
        if (enableLiveRegion) {
            if (isElementReoderUsingKeyboard && liveAriaObject.keyCode === 13) {
                dispatch(setAriaMoveText({
                    text: (liveAriaObject.isSection
                        ? sectionText + " " + liveAriaObject.section.title
                        : subSectionText + " " + liveAriaObject.subSection.title) +
                        " " +
                        grabText +
                        " " +
                        grabInfoText,
                }));
            }
            else if (!isElementReoderUsingKeyboard) {
                if (liveAriaObject.keyCode === 27) {
                    dispatch(setAriaMoveText({ text: elementReleased }));
                }
                else if (liveAriaObject.keyCode === 13) {
                    dispatch(setAriaMoveText({
                        text: (liveAriaObject.isSection
                            ? sectionText + " " + liveAriaObject.section.title
                            : subSectionText + " " + liveAriaObject.subSection.title) +
                            " " +
                            dropText,
                    }));
                }
            }
        }
        return (_jsx("div", Object.assign({ className: "sr-only", "aria-live": "polite", "aria-atomic": "true" }, { children: ariaMoveText })));
    };
    const addSectionHandler = (event, sortOrder, renderType, sectionUuid, title) => {
        event.preventDefault();
        setOpenAddEditModal(true);
        dispatch(openAddSectionModal({
            addSectionModal: true,
            currentSortOrder: sortOrder,
            renderType: renderType,
            currentSectionUuid: sectionUuid,
            title: title,
        }));
    };
    const openDeleteModal = (event, renderType, timelineUuid, sectionUuid, currentSortOrder) => {
        event.preventDefault();
        setIsDeleteModalOpen(true);
        dispatch(openDeleteSectionModal({
            deleteSectionModal: true,
            renderType: renderType,
            currentSectionUuid: sectionUuid,
            currentTimelineUuid: timelineUuid,
            currentSortOrder,
        }));
    };
    const closeAddEditModalHandler = (event) => {
        event.preventDefault();
        setOpenAddEditModal(false);
        dispatch(openAddSectionModal({
            addSectionModal: false,
            currentSortOrder: 0,
            renderType: "",
            currentSectionUuid: "",
            title: "",
        }));
        if (renderType === "edit-subsection") {
            focusActionMenuComponent("subsection-menu-" + currentSectionUuid);
        }
        else if (renderType === "edit-section") {
            focusActionMenuComponent("section-menu-" + currentSectionUuid);
        }
    };
    const closeDeleteModalHandler = (event) => {
        event.preventDefault();
        setIsDeleteModalOpen(false);
        dispatch(openDeleteSectionModal({
            deleteSectionModal: false,
            renderType: "",
            currentSectionUuid: "",
            currentTimelineUuid: "",
            currentSortOrder: 0,
        }));
        if (renderType === "delete-subsection") {
            focusActionMenuComponent("subsection-menu-" + currentSectionUuid);
        }
        else {
            focusActionMenuComponent("section-menu-" + currentSectionUuid);
        }
    };
    const updateTitleHandler = (event) => {
        event.preventDefault();
        dispatch(setModalTitle(event.target.value));
    };
    const saveSectionHandler = (event, renderType) => {
        if (modalTitle.trim() === "") {
            dispatch(setTitleError(true));
            return;
        }
        event.preventDefault();
        if (savedTitle !== modalTitle) {
            const data = {
                timelineUuid: timelineData.uuid,
                sectionUuid: currentSectionUuid,
                title: modalTitle,
                sortOrder: currentSortOrder,
            };
            if (renderType === "add-section") {
                setOpenAddEditModal(false);
                dispatch(addSectionToTimeline(data));
                focusActionMenuComponent("add-section-" + currentSectionUuid);
            }
            else if (renderType === "add-subsection") {
                setOpenAddEditModal(false);
                dispatch(addSubSectionToTimeline(data));
                focusActionMenuComponent("add-subsection" + currentSectionUuid);
            }
            else if (renderType === "edit-section") {
                setOpenAddEditModal(false);
                dispatch(editSection(data));
                focusActionMenuComponent("section-menu-" + currentSectionUuid);
            }
            else if (renderType === "edit-subsection") {
                setOpenAddEditModal(false);
                dispatch(editSubSection(data));
                focusActionMenuComponent("subsection-menu-" + currentSectionUuid);
            }
        }
        else {
            setOpenAddEditModal(false);
            dispatch(closeAddSectionModal());
        }
    };
    const deleteSectionHandler = (event, timelineUuid, id) => {
        event.preventDefault();
        if (renderType === "delete-section") {
            setIsDeleteModalOpen(false);
            dispatch(deleteSection({ timelineUuid, id }));
        }
        if (renderType === "delete-subsection") {
            setIsDeleteModalOpen(false);
            dispatch(deleteSubSection({ timelineUuid, id }));
        }
    };
    const finishedSnackHandler = (event) => {
        event.preventDefault();
        dispatch(closeSnackbar(event.detail.id));
    };
    const changePosition = (source, dest, insertBefore, emptyNodeIdentifier) => {
        dispatch(placeSubSectionToNewPosition({
            source,
            dest,
            insertBefore,
            emptyNodeIdentifier,
        }));
        setDraggedItem("");
        setDraggedEnterItem("");
        setIsDragStarted(false);
        setCategory("");
    };
    useEffect(() => {
        dispatch(setCacheTimelineData({ timelineData }));
        if (timelineData.sections) {
            let { sections } = timelineData;
            let updatedSections = [];
            for (let sec of sections) {
                let { uuid, subSections } = sec;
                let updatedSubsections = subSections.map((subSection) => {
                    return {
                        uuid: subSection.uuid,
                        sortOrder: subSection.sortOrder,
                        sectionUuid: subSection.sectionUuid,
                    };
                });
                updatedSections.push({
                    uuid,
                    sortOrder: sec.sortOrder,
                    subSections: updatedSubsections,
                });
            }
            let requestBody = { uuid: timelineData.uuid, sections: updatedSections };
            let identifier = setTimeout(() => {
                dispatch(updateSubSectionBulk({
                    timelineUuid: timelineData.uuid,
                    requestBody: requestBody,
                }));
            }, 500);
            return () => {
                clearTimeout(identifier);
            };
        }
    }, [timelineData]);
    const renderAddEditSectionModal = (isOpen, renderType) => {
        let dataLabel = "";
        let modalHeading = "";
        let primaryText = "";
        let modalFor = "";
        if (renderType === "add-section") {
            dataLabel = "Stage Title";
            modalHeading = "Add Stage";
            primaryText = "Add";
            modalFor = "stage";
        }
        else if (renderType === "add-subsection") {
            dataLabel = "Sub-Section Title";
            modalHeading = "Add Sub-Section";
            primaryText = "Add";
            modalFor = "sub-section";
        }
        else if (renderType === "edit-section") {
            dataLabel = "Stage Title";
            modalHeading = "Rename Stage";
            primaryText = "Update";
            modalFor = "stage";
        }
        else if (renderType === "edit-subsection") {
            dataLabel = "Sub-Section Title";
            modalHeading = "Edit Sub-Section";
            primaryText = "Update";
            modalFor = "sub-section";
        }
        return (_jsx(EditModalWithTwoButton, { isOpen: isOpen, onPrimaryClick: (event) => saveSectionHandler(event, renderType), onSecondaryClick: closeAddEditModalHandler, modalHeading: modalHeading, dataLabel: dataLabel, inputRef: inputRef, updateTitleHandler: updateTitleHandler, modalTitle: modalTitle, titleError: titleError, modalFor: modalFor, primaryText: primaryText, secondaryText: "Cancel" }));
    };
    const renderDeleteSectionModal = (isOpen, renderType) => {
        let modalHeading = "";
        let modalContent = "";
        let ariaLabelValue = "";
        if (renderType === "delete-section") {
            modalHeading = "Do you want to delete this Stage?";
            modalContent =
                "Deleting this Stage will also delete its Sub-Section and any requirements already added within these Stages. This cannot be undone.";
            ariaLabelValue = "Delete Section";
        }
        else if (renderType === "delete-subsection") {
            modalHeading = "Do you want to delete this Sub-Section?";
            modalContent =
                "Deleting this Sub-Section will also delete any requirements within it. This cannot be undone.";
            ariaLabelValue = "Delete Sub-Section";
        }
        return (_jsx(DeleteModal, { isOpen: isOpen, onPrimaryClick: (event) => deleteSectionHandler(event, currentTimelineUuid, currentSectionUuid), onSecondaryClick: closeDeleteModalHandler, modalContent: modalContent, modalHeading: modalHeading, ariaLabelValue: ariaLabelValue, modalId: "delete-modal", contentId: "content-delete-modal" }));
    };
    const dismissDrag = (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigateToElement(draggedItem);
        setDraggedItem("");
        setDraggedEnterItem("");
        hideGhostElement();
        setIsDragStarted(false);
    };
    const hideGhostElement = () => {
        let ghostElement = document.getElementById("ghost-element-container");
        if (ghostElement !== null) {
            ghostElement.style.display = "none";
        }
    };
    const keyDownHandler = (event, isSection, section, subSection) => {
        var _a;
        const keyCode = event.keyCode ? event.keyCode : event.which;
        if (!(keyCode === 9 && !isElementReoderUsingKeyboard)) {
            event.preventDefault();
        }
        if (keyCode === 13) {
            // enter click
            if (isElementReoderUsingKeyboard) {
                // commit Changes
                setIsElementReoderUsingKeyboard(false);
                setKeysDraggedEnterItem("");
                dispatch(commitCacheTimelineData({}));
                setLiveAriaObject({ isSection, subSection, section, keyCode });
            }
            else {
                setIsElementReoderUsingKeyboard(true);
                setEnableLiveRegion(true);
                setKeysDraggedEnterItem(isSection ? section.uuid : subSection.uuid);
                setLiveAriaObject({ isSection, subSection, section, keyCode });
            }
            setTimeout(() => {
                var _a;
                (_a = document
                    .getElementById("drag-icon-" + (isSection ? section.uuid : subSection.uuid))) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
        else if (keyCode === 40 || keyCode === 38) {
            // down key
            setLiveAriaObject({ isSection, subSection, section, keyCode });
            changePositionViaKeyboard(keysDraggedEnterItem, keyCode, false, isSection, section, subSection);
        }
        else if (keyCode === 9) {
            // Tab key
            if (isElementReoderUsingKeyboard) {
                (_a = document
                    .getElementById("drag-icon-" + (isSection ? section.uuid : subSection.uuid))) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                return;
            }
        }
        else if (keyCode === 27) {
            // Esc key
            setLiveAriaObject({ isSection, subSection, section, keyCode });
            setIsElementReoderUsingKeyboard(false);
            setKeysDraggedEnterItem("");
            dispatch(commitCacheTimelineData({ reset: true }));
            setTimeout(() => {
                var _a;
                (_a = document
                    .getElementById("drag-icon-" + (isSection ? section.uuid : subSection.uuid))) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    };
    useEffect(() => {
        let element = document.getElementById("drag-icon-" + keysDraggedEnterItem);
        if (element) {
            element.scrollIntoView();
            element.focus();
        }
    }, [cacheTimelineData]);
    const subheadingText = () => {
        return (_jsx("span", Object.assign({ className: "edit-timeline-subheading" }, { children: translate("app.edit.outline.subheading") })));
    };
    const changePositionViaKeyboard = (source, keyCode, persistInMain, isSection, section, subSection) => __awaiter(this, void 0, void 0, function* () {
        if (!blockMovement) {
            yield Promise.all([
                dispatch(setBlockMovement({ val: true })),
                dispatch(placeSecSubsecToNewPositionKeyboard({
                    source,
                    keyCode,
                    persistInMain,
                    movedToPosition,
                    isSection,
                    section,
                    subSection,
                })),
            ]);
            setDraggedItem("");
            if (persistInMain) {
                setDraggedEnterItem("");
                setKeysDraggedEnterItem("");
            }
        }
    });
    const isSubmissionReceivedForSection = (section) => {
        let isSubmitted = false;
        for (let req of section.requirements) {
            if (req.anyFileSubmitted ||
                req.acknowledgementSelected ||
                req.anySubmissionExist) {
                isSubmitted = true;
                break;
            }
        }
        section.subSections.map((subSec) => {
            for (let req of subSec.requirements) {
                if (req.anyFileSubmitted ||
                    req.acknowledgementSelected ||
                    req.reviewed ||
                    req.anySubmissionExist) {
                    isSubmitted = true;
                    break;
                }
            }
        });
        return isSubmitted;
    };
    const isSubmissionReceivedForSubSection = (subSection) => {
        let isSubmitted = false;
        for (let req of subSection.requirements) {
            if (req.anyFileSubmitted ||
                req.acknowledgementSelected ||
                req.reviewed ||
                req.anySubmissionExist) {
                isSubmitted = true;
                break;
            }
        }
        return isSubmitted;
    };
    const renderSubsection = (section, subSection, subSectionIndex, index) => {
        var _a, _b, _c;
        let ariaLabelText = `${moveText} ${subSectionText} ${subSection.title}`;
        return (_jsx(DraggableItem, Object.assign({ object: {
                uuid: subSection.uuid,
                title: subSection.title +
                    (((_a = subSection.requirements) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? " (" +
                            ((_b = subSection.requirements) === null || _b === void 0 ? void 0 : _b.length) +
                            " Requirement" +
                            (((_c = subSection.requirements) === null || _c === void 0 ? void 0 : _c.length) > 1 ? "s)" : ")")
                        : ""),
            }, draggedItem: draggedItem, setDraggedItem: setDraggedItem, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, index: subSectionIndex, isDragStarted: isDragStarted, setIsDragStarted: setIsDragStarted, categoryType: "subsection", setCategory: setCategory, category: category, numberOfElements: section.subSections.filter((elem) => elem.uuid !== draggedItem).length, maxElementsAllowed: Constants.maxSubSectionAllowed, isElementReoderUsingKeyboard: isElementReoderUsingKeyboard, keysDraggedEnterItem: keysDraggedEnterItem }, { children: _jsx("div", Object.assign({ className: "flex-row -justified subsection-content" }, { children: _jsxs("div", Object.assign({ className: "-contnr flex-row -justified" }, { children: [_jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsx("div", Object.assign({ id: `drag-icon-${subSection.uuid}`, className: "drag-svg-subsec", tabIndex: 0, role: "button", "aria-label": ariaLabelText, onKeyDown: (event) => keyDownHandler(event, false, section, subSection) }, { children: _jsxs("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("title", { children: "Drag & Drop" }), _jsx("g", Object.assign({ id: "UX:-Drag-&amp;-Drop_" + subSection.uuid, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", Object.assign({ id: "Section---Drag-&amp;-Drop-State_" + subSection.uuid, transform: "translate(-366.000000, -446.000000)" }, { children: _jsxs("g", Object.assign({ id: "Drag-&amp;-Drop-Icon_" + subSection.uuid, transform: "translate(366.000000, 446.000000)" }, { children: [_jsx("polygon", { id: "Path_" + subSection.uuid, points: "0 0 24 0 24 24 0 24" }), _jsx("path", { d: "M11,18 C11,19.1 10.1,20 9,20 C7.9,20 7,19.1 7,18 C7,16.9 7.9,16 9,16 C10.1,16 11,16.9 11,18 Z M9,10 C7.9,10 7,10.9 7,12 C7,13.1 7.9,14 9,14 C10.1,14 11,13.1 11,12 C11,10.9 10.1,10 9,10 Z M9,4 C7.9,4 7,4.9 7,6 C7,7.1 7.9,8 9,8 C10.1,8 11,7.1 11,6 C11,4.9 10.1,4 9,4 Z M15,8 C16.1,8 17,7.1 17,6 C17,4.9 16.1,4 15,4 C13.9,4 13,4.9 13,6 C13,7.1 13.9,8 15,8 Z M15,10 C13.9,10 13,10.9 13,12 C13,13.1 13.9,14 15,14 C16.1,14 17,13.1 17,12 C17,10.9 16.1,10 15,10 Z M15,16 C13.9,16 13,16.9 13,18 C13,19.1 13.9,20 15,20 C16.1,20 17,19.1 17,18 C17,16.9 16.1,16 15,16 Z", id: "Shape_" + subSection.uuid, fill: "#6B6B6B", fillRule: "nonzero" })] })) })) }))] })) })), _jsxs("div", Object.assign({ className: "body sub-section " }, { children: [_jsx("div", Object.assign({ className: "flex-row -justified -verticallycentered" }, { children: _jsx("div", Object.assign({ className: "subsection-label" }, { children: subSection.title })) })), (subSection === null || subSection === void 0 ? void 0 : subSection.requirements.length) > 0 ? (_jsxs(_Fragment, { children: [_jsxs(WmButton, Object.assign({ buttonType: "textonly", id: `subsection-requirement-${subSection.uuid}`, className: ` ${!subSection.isRequirementExpanded &&
                                                        subSection.title.length > 80
                                                        ? "long-label"
                                                        : ""}`, icon: subSection.isRequirementExpanded ? "f35d" : "f35f", "icon-size": "large", onClick: (event) => subtoggleHandler(event, subSection.isRequirementExpanded, true, index, subSection.uuid, dispatch, false), placeholder: undefined }, { children: [subSection.isRequirementExpanded ? "Hide " : "Show ", subSection === null || subSection === void 0 ? void 0 : subSection.requirements.length, " ", (subSection === null || subSection === void 0 ? void 0 : subSection.requirements.length) > 1
                                                            ? " Requirements"
                                                            : " Requirement"] })), _jsx("div", Object.assign({ className: subSection.isRequirementExpanded ? "show-reqts" : "" }, { children: subSection.isRequirementExpanded
                                                        ? subSection.requirements.map((reqt) => {
                                                            return (_jsx("div", Object.assign({ className: "left-indent" }, { children: reqt.title }), "requirements_" + reqt.uuid));
                                                        })
                                                        : "" }))] })) : (_jsx("div", Object.assign({ className: `body no-requirements ${subSection.title.length > 80 ? "long-label" : ""}` }, { children: translate("app.licensurePlans.noReq") })))] }), "subSection" + subSection.uuid)] })), _jsx("div", Object.assign({ className: "button-collection" }, { children: _jsxs(WmActionMenu, Object.assign({ "action-menu-type": "icon", tooltip: "Options", id: "subsection-menu-" + subSection.uuid, placeholder: undefined }, { children: [_jsx(WmMenuitem, Object.assign({ icon: "f3eb", id: "edit-subsection-" + subSection.uuid, "label-for-identical-buttons": "Edit " + subSection.title, onClick: (event) => addSectionHandler(event, 1, "edit-subsection", subSection.uuid, subSection.title), placeholder: undefined }, { children: translate("app.viewTimeline.edit.requirement") })), isSubmissionReceivedForSubSection(subSection) ? ("") : (_jsx(WmMenuitem, Object.assign({ icon: "f1c0", id: "delete-subsection-" + subSection.uuid, "label-for-identical-buttons": "Delete " + subSection.title, onClick: (event) => openDeleteModal(event, "delete-subsection", section.timelineUuid, subSection.uuid, section.sortOrder), placeholder: undefined }, { children: translate("app.viewTimeline.delete.requirement") })))] })) }))] })) })) }), subSection.uuid));
    };
    const mainContent = () => {
        let addDropZone = false;
        let addToNextElem = false;
        return (_jsxs(DraggableArea, Object.assign({ dismissDrag: dismissDrag, category: category }, { children: [_jsx("div", Object.assign({ className: "immersive-container flyout-data" }, { children: _jsxs("div", Object.assign({ className: `flyout-content edit-outline-content  ${isDragStarted ? "dragIsStarted" : ""} `, role: "application" }, { children: [timelineSections &&
                                timelineSections.length < 10 &&
                                !isDragStarted ? (_jsx("div", Object.assign({ className: "btn-color", onClick: (event) => addSectionHandler(event, 1, "add-section", "", "") }, { children: _jsx(WmButton, Object.assign({ buttonType: "textonly", icon: "F419", id: "add-section-1", class: "btn-background", placeholder: undefined }, { children: translate("app.requirement.edit_requirement.add_stage.label") })) }))) : null, timelineSections
                                ? timelineSections.map((section, index) => {
                                    var _a, _b, _c;
                                    let ariaLabelText = `${moveText} ${sectionText} ${section.title}`;
                                    addDropZone = false;
                                    if ((index === 0 && section.uuid !== draggedItem) ||
                                        addToNextElem) {
                                        addDropZone = true;
                                        addToNextElem = false;
                                    }
                                    else if (index === 0 && section.uuid === draggedItem) {
                                        addToNextElem = true;
                                    }
                                    else if (index === 0) {
                                        addToNextElem = true;
                                    }
                                    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsxs("div", Object.assign({ className: "paper-card section-card edit card-width edit-outline-card" }, { children: [addDropZone && isDragStarted ? (_jsx(DropZone, Object.assign({ nodeId: "section-top", nodeIdentifier: "section-outline", elements: 0, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, isDragStarted: isDragStarted, category: category, height: "10px" }, { children: "" }))) : (""), _jsx(DraggableItem, Object.assign({ object: {
                                                                uuid: section.uuid,
                                                                title: section.title +
                                                                    (((_a = section.subSections) === null || _a === void 0 ? void 0 : _a.length) > 0
                                                                        ? " (" +
                                                                            ((_b = section.subSections) === null || _b === void 0 ? void 0 : _b.length) +
                                                                            " Sub-Section" +
                                                                            (((_c = section.subSections) === null || _c === void 0 ? void 0 : _c.length) > 1
                                                                                ? "s)"
                                                                                : ")")
                                                                        : ""),
                                                            }, draggedItem: draggedItem, setDraggedItem: setDraggedItem, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, index: index, isDragStarted: isDragStarted, setIsDragStarted: setIsDragStarted, categoryType: "section", setCategory: setCategory, category: category, isElementReoderUsingKeyboard: isElementReoderUsingKeyboard, keysDraggedEnterItem: keysDraggedEnterItem }, { children: _jsxs("div", Object.assign({ className: "header section-header flex-row -justified -verticallycentered " }, { children: [_jsxs("div", Object.assign({ className: "flex-row -justified -verticallycentered " }, { children: [_jsx("div", Object.assign({ id: `drag-icon-${section.uuid}`, className: "drag-svg-section", tabIndex: 0, role: "button", "aria-label": ariaLabelText, onKeyDown: (event) => keyDownHandler(event, true, section, {}) }, { children: _jsxs("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, { children: [_jsx("title", { children: "Drag & Drop" }), _jsx("g", Object.assign({ id: "UX:-Drag-&amp;-Drop_" + section.uuid, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: _jsx("g", Object.assign({ id: "Section---Drag-&amp;-Drop-State_" +
                                                                                                    section.uuid, transform: "translate(-366.000000, -446.000000)" }, { children: _jsxs("g", Object.assign({ id: "Drag-&amp;-Drop-Icon_" +
                                                                                                        section.uuid, transform: "translate(366.000000, 446.000000)" }, { children: [_jsx("polygon", { id: "Path_" + section.uuid, points: "0 0 24 0 24 24 0 24" }), _jsx("path", { d: "M11,18 C11,19.1 10.1,20 9,20 C7.9,20 7,19.1 7,18 C7,16.9 7.9,16 9,16 C10.1,16 11,16.9 11,18 Z M9,10 C7.9,10 7,10.9 7,12 C7,13.1 7.9,14 9,14 C10.1,14 11,13.1 11,12 C11,10.9 10.1,10 9,10 Z M9,4 C7.9,4 7,4.9 7,6 C7,7.1 7.9,8 9,8 C10.1,8 11,7.1 11,6 C11,4.9 10.1,4 9,4 Z M15,8 C16.1,8 17,7.1 17,6 C17,4.9 16.1,4 15,4 C13.9,4 13,4.9 13,6 C13,7.1 13.9,8 15,8 Z M15,10 C13.9,10 13,10.9 13,12 C13,13.1 13.9,14 15,14 C16.1,14 17,13.1 17,12 C17,10.9 16.1,10 15,10 Z M15,16 C13.9,16 13,16.9 13,18 C13,19.1 13.9,20 15,20 C16.1,20 17,19.1 17,18 C17,16.9 16.1,16 15,16 Z", id: "Shape_" + section.uuid, fill: "#6B6B6B", fillRule: "nonzero" })] })) })) }))] })) })), _jsxs("h2", Object.assign({ className: "title section-title" }, { children: [" ", section.title, " "] }))] })), _jsx("div", Object.assign({ className: "flex-row button-collection" }, { children: _jsxs(WmActionMenu, Object.assign({ "action-menu-type": "icon", tooltip: "Options", id: "section-menu-" + section.uuid, placeholder: undefined }, { children: [_jsx(WmMenuitem, Object.assign({ icon: "f3eb", id: "edit-section-" + section.uuid, "label-for-identical-buttons": "Edit " + section.title, onClick: (event) => addSectionHandler(event, 1, "edit-section", section.uuid, section.title), placeholder: undefined }, { children: translate("app.editTimeline.rename.stages") })), timelineSections.length == 1 ? (_jsx(WmMenuitem, Object.assign({ disabled: true, icon: "f1c0", id: "delete-section-" + section.uuid, "label-for-identical-buttons": "Delete " + section.title, placeholder: undefined }, { children: translate("app.viewTimeline.delete.requirement") }))) : isSubmissionReceivedForSection(section) ? ("") : (_jsx(WmMenuitem, Object.assign({ icon: "f1c0", id: "delete-section-" + section.uuid, "label-for-identical-buttons": "Delete " + section.title, onClick: (event) => openDeleteModal(event, "delete-section", section.timelineUuid, section.uuid, section.sortOrder), placeholder: undefined }, { children: translate("app.viewTimeline.delete.requirement") })))] })) }))] })) }), section.uuid), isDragStarted && category == "section" ? ("") : (_jsxs(_Fragment, { children: [(section === null || section === void 0 ? void 0 : section.requirements.length) > 0 ? (_jsxs("div", Object.assign({ className: "body section-requirements" }, { children: [_jsxs(WmButton, Object.assign({ buttonType: "textonly", id: `section-requirement-${section.uuid}`, icon: section.isRequirementExpanded
                                                                                ? "f35d"
                                                                                : "f35f", "icon-size": "large", onClick: (event) => toggleHandler(event, section.isRequirementExpanded, true, index, dispatch, false), placeholder: undefined }, { children: [section.isRequirementExpanded
                                                                                    ? "Hide "
                                                                                    : "Show ", section === null || section === void 0 ? void 0 : section.requirements.length, (section === null || section === void 0 ? void 0 : section.requirements.length) > 1
                                                                                    ? " Requirements"
                                                                                    : " Requirement"] })), section.isRequirementExpanded
                                                                            ? section.requirements.map((reqt) => {
                                                                                return (_jsx("div", Object.assign({ className: "left-indent" }, { children: reqt.title }), "requirements_" + reqt.uuid));
                                                                            })
                                                                            : ""] }))) : section.subSections.length > 0 ? ("") : (_jsx("div", Object.assign({ className: "body no-requirements" }, { children: translate("app.licensurePlans.noReq") }))), isDragStarted &&
                                                                    section.uuid != draggedItem &&
                                                                    category == "subsection" ? (_jsx(DropZone, Object.assign({ nodeId: section.uuid, nodeIdentifier: "subsection-outline", elements: section.subSections.length, draggedEnterItem: draggedEnterItem, setDraggedEnterItem: setDraggedEnterItem, changePosition: changePosition, isDragStarted: isDragStarted, category: category }, { children: "" }))) : (""), _jsx("div", { children: section.subSections.length > 0
                                                                        ? section.subSections.map((subSection, subSectionIndex) => {
                                                                            return renderSubsection(section, subSection, subSectionIndex, index);
                                                                        })
                                                                        : null }), section.subSections.length < 10 ? (_jsx("div", Object.assign({ className: "body add-sub-section" }, { children: _jsx(WmButton, Object.assign({ buttonType: "textonly", icon: "F419", id: "add-subsection-" + section.uuid, onClick: (event) => addSectionHandler(event, section.subSections.length + 1, "add-subsection", section.uuid, ""), placeholder: undefined }, { children: "Add Sub-Section" })) }))) : null] }))] })), _jsx("div", Object.assign({ className: "body " }, { children: timelineSections &&
                                                        timelineSections.length < 10 &&
                                                        !isDragStarted ? (_jsx("div", Object.assign({ className: "btn-color", onClick: (event) => addSectionHandler(event, index + 2, "add-section", "", "") }, { children: _jsx(WmButton, Object.assign({ buttonType: "textonly", class: "btn-background", icon: "F419", id: "add-section-" + section.uuid, placeholder: undefined }, { children: translate("app.requirement.edit_requirement.add_stage.label") })) }))) : null }))] }, "section" + section.uuid) }));
                                })
                                : null] }), "flyout-content edit-outline-content") })), renderAddEditSectionModal(openAddEditModal, renderType), renderDeleteSectionModal(isDeleteModelOpen, renderType), renderLiveRegion(), _jsx(WmSnackbar, { notifications: snackNotifications, id: "licensure-plans-snack", onWmSnackbarSnackFinished: (event) => finishedSnackHandler(event), placeholder: undefined })] })));
    };
    return (_jsx(Flyout, { id: "edit-timeline-flyout", mainContent: mainContent(), closeFlyoutHandler: (event) => closeEditTimelineHandler(event), heading: "Edit Outline", subHeading: subheadingText(), primaryButton: translate("app.editTimeline.primaryButtonText"), primaryActionHandler: (event) => closeEditTimelineHandler(event), breadCrum: "", showSecondaryButton: false, secondaryButton: translate("app.cohort.secondaryButtonText"), secondaryButtonActionHandler: () => { }, disableActionButtons: false, showStatus: "" }));
}
